import React from "react";
import { NavLink } from "react-router-dom";

const NDOTSubNav = ({ role, handleSettingCurrentPage, hasManagedDept, hasTMSManagedDept }) => {
    // show both tabs for admins
    if (role === 'admin') {
        return (
            <ul>
                <li>
                    <NavLink to="nd-ot/my-request" onClick={() => handleSettingCurrentPage('ndot')}>My Request</NavLink>
                </li>
                <li>
                    <NavLink to="nd-ot/all-requests" onClick={() => handleSettingCurrentPage('ndot')}>All Requests</NavLink>
                </li>
            </ul>
        );
    }

    // show both tabs for manager/supervisor if they manage a department
    if ((role === 'manager' || role === 'supervisor') &&
    (hasManagedDept || hasTMSManagedDept)) {
        return (
            <ul>
                <li>
                    <NavLink to="nd-ot/my-request" onClick={() => handleSettingCurrentPage('ndot')}>My Request</NavLink>
                </li>
                <li>
                    <NavLink to="nd-ot/all-requests" onClick={() => handleSettingCurrentPage('ndot')}>All Requests</NavLink>
                </li>
            </ul>
        );
    }

    return (
        <ul>
            <li>
                <NavLink to="nd-ot/my-request" onClick={() => handleSettingCurrentPage('ndot')}>My Request</NavLink>
            </li>
        </ul>
    );
};

export default NDOTSubNav;
